import GetStartedMarketplace from "../screen/container/get-started/marketplace/get-started-marketplace";

export const routesMarketplace = [
    {
        path: "/get-started-mplace",
        exact: true,
        component: GetStartedMarketplace,
        guard: "public",
    },
];